import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { Component, JSX } from 'solid-js';

export interface FxBreaklinesPublishAllButtonProps {
  readonly workspaceId: string;
}

export const FxBreaklinesPublishAllButton: Component<
  FxBreaklinesPublishAllButtonProps
> = (props): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handlePublishAll = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.publishAllBreaklines(props.workspaceId);
  };

  return (
    <button
      type="button"
      class="inline-flex h-8 items-center gap-1 rounded px-2 text-xs hover:bg-background-secondary"
      aria-label={t('mobileMapping.fxWorkspace.breaklines.publishAll')}
      title={t('mobileMapping.fxWorkspace.breaklines.publishAll')}
      data-testid={`fx-breaklines-publish-all-${props.workspaceId}`}
      onClick={handlePublishAll}
      onPointerDown={stopTreeRowInteraction}
    >
      <i class="icon-font tc-icon-launch i16" aria-hidden="true" />
      <span>{t('mobileMapping.fxWorkspace.breaklines.publishAll')}</span>
    </button>
  );
};
